import { ReactNode } from 'react';
import PdfSiBackpack from './icons/PdfSiBackpack';
import PdfSiBattery from './icons/PdfSiBattery';
import PdfSiCoins from './icons/PdfSiCoins';
import PdfSiCommand from './icons/PdfSiCommand';
import PdfSiGaming from './icons/PdfSiGaming';
import PdfSiInformation from './icons/PdfSiInformation';
import PdfSiKeyboard2 from './icons/PdfSiKeyboard2';
import PdfSiLaptop from './icons/PdfSiLaptop';
import PdfSiMonitor from './icons/PdfSiMonitor';
import PdfSiMouse from './icons/PdfSiMouse';
import PdfSiUsb from './icons/PdfSiUsb';

const icons: Record<string, ReactNode> = {
  monitors: <PdfSiMonitor />,
  laptops: <PdfSiLaptop />,
  keyboard: <PdfSiKeyboard2 />,
  power: <PdfSiBattery />,
  bag: <PdfSiBackpack />,
  mouse: <PdfSiMouse />,
  connection: <PdfSiUsb />,
  fee: <PdfSiCoins />
};

// This is a slightly odd pattern in that we're using a Proxy to provide
// custom logic on how to handle icons that aren't found in the icons object
// or use a different name. Here we're able to transparently handle the
// different names for the same icon without having to define multiple entries.
export const PdfCategoryIcons = new Proxy(icons, {
  get: function (target, name) {
    if (typeof name === 'symbol') throw new Error('Symbol not supported');
    const icon = target[name];
    // If we have an icon, return it
    if (icon) return icon;

    // Otherwise, try to find an icon that matches the name
    switch (name.toLowerCase()) {
      case 'chip':
        return <PdfSiGaming />;
      case 'gaming':
        return <PdfSiGaming />;
      case 'command':
        return <PdfSiCommand />;
      default:
        return <PdfSiInformation />;
    }
  }
});
